import { render, staticRenderFns } from "./ProvinceEdit.vue?vue&type=template&id=0c74a586&scoped=true"
import script from "./ProvinceEdit.vue?vue&type=script&lang=js"
export * from "./ProvinceEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c74a586",
  null
  
)

export default component.exports